module.exports = __webpack_public_path__ + "prod/1.42.2/img/premium.95485b26.png";